import React from 'react';

import { BED_STATE_PILLS } from '../../../constants/occupancy';

/**
 * StateFilterChips (C2 / FT8) — the state filter. Selecting a state DIMS the
 * non-matching tiles (WardGroup `dimState`) — it NEVER removes a tile, so the
 * layout is stable and the header/strip counts stay whole-truth. Chip set is
 * derived from the single-source BED_STATE_PILLS so it can't diverge from the
 * legend. Inactive chips carry a solid background (visible without hover, light
 * + dark) per the transparency rule.
 */
export default function StateFilterChips({ value = '', onChange }) {
  const pills = [{ code: '', label: 'All' }, ...BED_STATE_PILLS];
  return (
    <div role="group" aria-label="State filter" className="flex flex-wrap gap-1.5">
      {pills.map((p) => {
        const active = value === p.code;
        return (
          <button
            key={p.code || 'all'}
            type="button"
            data-testid={`state-chip-${p.code || 'all'}`}
            aria-pressed={active}
            onClick={() => onChange?.(p.code)}
            className={
              active
                ? 'rounded-full bg-teal-600 px-2.5 py-1 text-xs font-semibold text-white'
                : 'rounded-full border border-slate-300 bg-white px-2.5 py-1 text-xs font-medium text-slate-700 hover:bg-slate-100 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700'
            }
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
